<template>
  <!-- 动态加载组件 -->
  <component :pulldata="data" :is="isComponent"></component>
</template>
<script>
import {
  getselfreport,
} from "@/api/course";
import { isMain,getSessionStorage } from '@/utils/tools'
import { newCourse } from '@/utils/course'
import index1 from "@/views/course/project_report/index1"
import index2 from "@/views/course/project_report/index2"

export default {
  data() {
      return {
        cid: null,
        data: {},
        isComponent:''
      }
    },
    components: {
      index1,
      index2
    },
    methods: {
      pullData() {
        this.$toast.loading({
          mask: true,
          message: "加载中..."
        });
        let querys = this.$route.query;
        this.cid = querys.cid;
        getselfreport({
            cid: querys.cid,
            cpid: querys.cpid,
            taskid: querys.taskid
          })
          .then((data) => {
            this.$toast.clear();
            this.data = data;
            // document.title = data.bigCourseName;
            // 判断是哪一个课（bid为1或2）
            if((!isMain()|| newCourse(this.cid)) && (data.bid===2 || getSessionStorage('request','/bid') && getSessionStorage('request','/bid')==2)){
              this.isComponent = index2;
            }else{
              this.isComponent = index1;
            }
          })
      }
    },
    created() {
      this.pullData();
    },
}
</script>